import { render, staticRenderFns } from "./WsSlickSort.vue?vue&type=template&id=a28ec1e6&"
import script from "./WsSlickSort.vue?vue&type=script&lang=js&"
export * from "./WsSlickSort.vue?vue&type=script&lang=js&"
import style0 from "./WsSlickSort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports